<template>
    <div >
         <waiting :open="openModalWaiting"/>
        <tournoi-list-vue
             v-if="nav=='tournois'" 
            :club="clubData"
            @openInscription="openInscription"
            :role="role"
            :saison="saison"
            :key="clubData.id"
            ref="listTounois"
        />
       
        <tournoi-inscription-vue
            v-if="nav=='inscription'  && tournoiSelected!=null"
            :club="clubData"            
            @close="nav='tournois'"
            @save="save"
            @refresh="refresh"
            :tournoi="tournoiSelected"
            @inprogress="inprogress"
            @nav="setNav"
            :role="role"
            :saison="saison"
            :key="tournoiSelected.id"
        ></tournoi-inscription-vue>

        <tournoi-resultat-vue
            v-if="nav=='resultat'  && tournoiSelected!=null"
            @viewGame="inprogress"
            :tournoi="tournoiSelected"
            :club="clubData"
            @back="nav='tournois'"
            :role="role"
            @listJoueurs = "nav='list'"
            @nav="setNav"
            :key="tournoiSelected.id"
        >
        </tournoi-resultat-vue>
        <tournoi-resultat-passed-vue
            v-if="nav=='resultatEdit'  && tournoiSelected!=null"
            @viewGame="inprogress"
            :tournoi="tournoiSelected"
            :club="clubData"
            @back="nav='tournois'"
            :role="role"
            @listJoueurs = "nav='list'"
            @nav="setNav"
            :key="tournoiSelected.id"
        >
        </tournoi-resultat-passed-vue>

        <tournoi-resultat-pool-vue
            v-if="nav=='resultatPool'  && tournoiSelected!=null"
            @viewGame="inprogress"
            :tournoi="tournoiSelected"
            :club="clubData"
            @back="nav='tournois'"
            :role="role"
            @listJoueurs = "nav='list'"
            @nav="setNav"
            :key="tournoiSelected.id"
            @changeIndexPartie="changeIndexPartie"
        >

        </tournoi-resultat-pool-vue>


        <tournoi-list-joueurs-vue
            v-if="nav=='list'  && tournoiSelected!=null"
            @viewGame="inprogress"
            :tournoi="tournoiSelected"
            :club="clubData"
            :role="role"
            @back="setNav"
            @resultat = "nav='resultat'"
            @nav="setNav"
           :key="tournoiSelected.id"
           
        >

        </tournoi-list-joueurs-vue>
        <game-inprogress-vue 
            v-if="nav=='progressTournoi' && tournoiSelected!=null"
            :club="clubData" 
            @close="nav='tournois'"
            :nav="nav"
            @save="save"
            :role="role"
            :tournoi="tournoiSelected"
            :joueurs="tournoiSelected.joueurs"
            @saveScore="saveScore"
            @resultat = "nav='resultat'"
            @listJoueurs = "nav='list'"
            @back="nav='tournois'" 
            @setState="setState"
            @refresh="refreshInProgress"
            @nav="setNav"
            :key="tournoiSelected.id"
            :indexPartieParam = "indexPartie"
            @changeIndexPartie="changeIndexPartie"
            >
            
        </game-inprogress-vue>
        <s-modal-code
            :open="openConfirmCode"
            :club="clubData"
            @close="openConfirmCode=false"
            @valid="valideCode()"
        />
       
        
    </div>
</template>
<style scoped>
    @media screen and (min-width: 420px) {  
        .demo {
            position: fixed;
            top: 10px;
            left: 380px;
            z-index: 30;
        }
    }
    @media screen and (max-width: 420px) {
        .demo {
            position: fixed;
            bottom: 100px;
            left: 5px;
            z-index: 30;
        }  
    }
    
    .errorCode {
        margin: 20px;
        color: rgb(212, 45, 45);
        font-weight: bolder;
    }
</style>
<script>
import club                     from '@/firebase/club'
import season_fct                     from '@/firebase/season'
import tournoi_fct              from '@/firebase/tournoi'



import TournoiListVue           from '@/views/tournoi/list.vue'
import TournoiInscriptionVue    from '@/views/tournoi/inscription.vue'
import GameInprogressVue        from '@/views/tournoi/inProgress.vue'
import TournoiResultatVue         from '@/views/tournoi/resultat.vue'
import TournoiResultatPassedVue         from '@/views/tournoi/resultat/resultatEdit.vue'
import TournoiResultatPoolVue         from '@/views/tournoi/resultatPool.vue'

import TournoiListJoueursVue           from '@/views/tournoi/listJoueurs.vue'
import firebase_api from "@/firebase/firebase_api"
import firebase from "firebase"
export default {
    data() {
        return {
            tounois:[],
            clubData: {},           
            nav : '',
            tournoiInProgressData: null,
            joueurs: [],
            indexTournoiSelected: null,
            tournoiSelected: null,
            saison: null,
            openModalWaiting: false,
            openConfirmCode: false,
            destroy: false,
            validateInprogress: false,
            indexPartie : 0,
            verifyCode: false
        }
    },
    watch: {
        nav(newNav, oldNav) {
            var minimize = false;
            if (this.nav!='tournois') {
                minimize = true;
            }
            else {
                this.indexPartie = 0;
                if (this.clubData.id=='demo' && oldNav!='') {
                    if (this.$store.getters.getUser.email=='anonyme@petanque-app.com')
                        this.$router.push({name: "home"})
                    else
                        this.$router.push({name: "club"})
                }
            }
            this.$store.dispatch("setMinimize", {
                    value: minimize
            })
        },
        routeSaison(val) {
            if (typeof(val)=="undefined") {
                this.saison = null;
               
            }
        }
    },
    components: {
        TournoiListVue,
        TournoiInscriptionVue,
        GameInprogressVue,
        TournoiResultatVue,
        TournoiListJoueursVue,
        TournoiResultatPoolVue,
        TournoiResultatPassedVue
    },
    computed: {
        role: {
            get() {
                if (this.clubData.id=="demo")
                    return "owner";
                else
                    return this.$getRole();
            }
        },
        routeSaison: {
            get() {
                return this.$route.params.idSeason;
            }
        }
    },
    methods: {
       
        setNav(nav) {
            this.nav  = nav;
        },
        refreshInProgress() {
            this.nav="";
            setTimeout (()=>{
                this.nav="progressTournoi";
            }, 200)
            
        },
        setState(state) {
            this.openModalWaiting = true;
           if(state == "INSCRIPTION") {
                //this.tournoiSelected.joueurs = [];
                this.nav = "inscription";
                this.indexPartie = 0;
                setTimeout (()=>{
                    tournoi_fct.object.setState(this.clubData, this.tournoiSelected, "INSCRIPTION", ()=>{
                        this.openModalWaiting = false;
                    })
                }, 200)
            }
        },
        refresh(tournoi) {
           
            this.tournoiSelected = tournoi;
        },
        valideCode() {
            this.verifyCode = true;
             this.openConfirmCode = false;
            this.openInscription(this.tournoiSelected)
        },
        openInscription(tournoi) {
            //this.tournoiSelected = tournoi;
          
            if (this.role!="visiteur" || this.verifyCode || this.clubData.id == "demo") {
                this.verifyCode = false;
                   
                this.$bind("tournoiSelected", firebase_api.api.getDb().collection("club").doc(this.clubData.id)
                    .collection("tournois").doc(tournoi.id)
                ).then(()=>{
                    if (tournoi.state == "INSCRIPTION")
                        this.nav = "inscription";
                    else if (tournoi.state == "INPROGRESS")
                        this.nav = 'progressTournoi'
                    else if( tournoi.options.competition == 3)
                        this.nav='resultatPool';
                    else
                        this.nav='resultat';
                })
            }
            else {
                
                this.tournoiSelected = tournoi;
                this.openConfirmCode = true;
            }
                /* tournoi_fct.object.getTournoiInprocess(this.clubData.tournois[this.indexTournoiSelected], (tournoiInProcess)=> {
                     this.tournoiInProgressData = tournoiInProcess;
                      this.joueurs = this.clubData.tournois[this.indexTournoiSelected].joueurs;
                     this.nav='resultat';
                 })*/
            
                
        },
        changeIndexPartie(indexPartie) {
           
            this.indexPartie = indexPartie;
        },
        saveScore() {
            tournoi_fct.object.saveTournoi(this.clubData, this.tournoiInProgressData, ()=>{
                //on vérifie si la partie est terminé ?
            })
        },
        inprogress() {
            //this.nav='progressTournoi';
           
            this.$bind("tournoiSelected", firebase_api.api.getDb().collection("club").doc(this.clubData.id)
                .collection("tournois").doc(this.tournoiSelected.id)
            ).then(()=>{
                if (this.tournoiSelected.state == "INSCRIPTION") {
                        this.nav = "inscription";
                }
                else if (this.tournoiSelected.state == "INPROGRESS") {
                    this.nav='progressTournoi';/*
                    tournoi_fct.object.getTournoiInprocess(this.clubData.tournois[this.indexTournoiSelected], (tournoiInProcess)=> {
                        this.tournoiInProgressData = tournoiInProcess;
                        this.joueurs = this.clubData.tournois[this.indexTournoiSelected].joueurs;
                        this.nav='progressTournoi';
                    })*/
                }
                else {
                    this.indexPartie = 0;
                    this.nav='progressTournoi';
                  //  this.tournoiSelected.state = "INPROGRESS";
                    
                /* tournoi_fct.object.setTournoi(this.clubData, this.clubData.tournois[this.indexTournoiSelected], 
                        tournoi=>{
                            this.tournoiInProgressData = tournoi;
                            this.joueurs = this.clubData.tournois[this.indexTournoiSelected].joueurs;
                            this.nav='progressTournoi';
                    })*/
                }
            });
        },
        
        save() {
            club.object.set(this.clubData,()=>{})
        }
     
    },
    mounted() {
        var idClub = this.$route.params.id;
       
        club.object.get(idClub, clubData=>{
          
            if (typeof(this.$route.params.idSeason)!="undefined") {
                season_fct.object.get(clubData, this.$route.params.idSeason, saisonData=>{
                    this.saison = saisonData;
                    this.clubData = clubData;
                    this.nav = "tournois";
                })
            }
            else {
                this.clubData = clubData;
                this.nav = "tournois";
            }
        })
      
    }
}
</script>